module.exports = __webpack_public_path__ + "static/img/belts.d8df7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/belts.jpg
// module id = mDbw
// module chunks = 1